import React from 'react';
import CustomLink from './CustomLink';

const crumbsMapper = (item, index) => {
  if (item.href) {
    return (
      <span key={index}>
        <CustomLink href={item.href} as={item.as}>{item.title}</CustomLink>
        <span className="separator" />
      </span>
    );
  }
  return <span key={index} className="current">{item.title}</span>;
};

const BreadCrumbs = ({ crumbs }) => (
  <div className="container">
    <div className="bread-crumbs">{crumbs.map(crumbsMapper)}</div>
  </div>
);

export default React.memo(BreadCrumbs);
